<template>
  <div class="header-page">
    <el-menu router  :default-active="$route.path" class="el-menu-demo" mode="horizontal" background-color="#545c64" text-color="#fff" active-text-color="#ffd04b">
      <el-menu-item index="/home"><span v-if="language === 'ch'">首页</span><span v-else>Home</span></el-menu-item>
      <el-submenu index="2">
        <template slot="title"> <span v-if="language === 'ch'">关于</span><span v-else>About</span></template>
        <el-menu-item index="/about"><span v-if="language === 'ch'">简介</span><span v-else>Introduction</span></el-menu-item>
        <el-menu-item index="/aboutProduct"><span v-if="language === 'ch'">生产设备</span><span v-else>Production Equipment</span></el-menu-item>
        <el-menu-item index="/aboutDesign"><span v-if="language === 'ch'">设计和测试</span><span v-else>Design and testing</span></el-menu-item>
      </el-submenu>
      <el-submenu index="3">
        <template slot="title"><span v-if="language === 'ch'">服务</span><span v-else>Service Process</span></template>
        <el-menu-item index="/service"><span v-if="language === 'ch'">业务团队</span><span v-else>Business Team</span></el-menu-item>
        <el-menu-item index="/serviceOrder"><span v-if="language === 'ch'">订单流程</span><span v-else>Orders Process</span></el-menu-item>
        <el-menu-item index="/serviceQuality"><span v-if="language === 'ch'">品控</span><span v-else>Quality Control</span></el-menu-item>
      </el-submenu>
      <el-menu-item index="/product"><span v-if="language === 'ch'">产品</span><span v-else>Products</span></el-menu-item>
      <el-submenu index="5">
        <template slot="title"><span v-if="language === 'ch'">伙伴关系</span><span v-else>Partnership</span></template>
        <el-menu-item index="/cooperate"><span v-if="language === 'ch'">合作伙伴</span><span v-else>Partner</span></el-menu-item>
      </el-submenu>
      <el-submenu index="6">
        <template slot="title"><span v-if="language === 'ch'">联系我们</span><span v-else>Contact Us</span></template>
        <el-menu-item index="/contactUs"><span v-if="language === 'ch'">联系我们</span><span v-else>Contact Us</span></el-menu-item>
        <!-- <el-menu-item index="/contactMessage"><span v-if="language === 'ch'">留言</span><span v-else>Message</span></el-menu-item> -->
      </el-submenu>
      <div class="login">
        <span @click="goPage">MSL-welcomespan <span class="line">|</span></span>
        <span @click="changeLanguage('en')">English <span class="line">|</span></span>
        <span @click="changeLanguage('ch')">中文版</span>
      </div>
    </el-menu>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: '/home',
      language: ''
    };
  },
  methods: {
    goPage() {
      this.$router.push("/")
    },
    changeLanguage(type) {
      localStorage.setItem("curlanguage", type)
      this.$router.go(0)
    }
  },
  mounted() {
    this.language = localStorage.getItem('curlanguage')
  }
}
</script>

<style scoped>
.header-page {
  width: 100%;
  background-color: rgb(84, 92, 100);
}
.el-menu-demo {
  min-width: 1130px;
}
.login {
  line-height: 60px;
  float: right;
  margin-right: 48px;
  cursor: pointer;
  color: #ffffff;
  font-size: 14px;
}
.line {
  padding: 5px;
  display: inline-block;
}
</style>
